import type { CreateProjectUserBody, ProjectPathParams } from '@si/types';
import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

type CreateProjectUserParams = ProjectPathParams & CreateProjectUserBody;

export function useCreateProjectUser() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: CreateProjectUserParams) =>
      post({
        url: `/projects/${params.projectId}/team`,
        body: params,
      }),
    onSuccess: (_, { projectId }) =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.getProjectUsers(projectId),
      }),
  });

  const createProjectUser = useCallback(
    (params: CreateProjectUserParams) => mutate(params),
    [mutate]
  );

  return {
    createProjectUser,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
